import React from 'react';
import { AtlassianLogo } from '@atlaskit/logo';
import { ContainerLayoutType, UserDataType } from '../../../../../../model';
import { useSignUpFormConfig } from '../../../../../../hook';
import { Signup } from '../signup';
import {
  LogoWrapper,
  RightContainerContent,
  RightContainerContentDefaultExpandedEmail
} from './styled';
import Spinner from '@atlaskit/spinner';
import styled from '@emotion/styled';

import { Labels, View as SignUpFormHeader } from '../../../sign-up-form-header';
import { useAppSelector } from '../../../../../../redux';

export function FirstImpressionsForm(props: ContainerLayoutType) {
  const { edition } = useSignUpFormConfig();
  const formHeaderLabels = Labels.useFormHeaderLabels({
    edition: edition || '',
    labels: props.labels,
    productKeys: props.productKeys
  });
  const {
    userInfo,
    isMigrationSignup,
    migrationData,
    allowSignupWithAllSocialOptions
  } = props;
  const { isLoggedIn = false } = userInfo || {};
  const { enableDefaultExpandedEmail } = useAppSelector(
    (state) => state.featureFlags
  );

  const isConfluence =
    (props.productKeys ?? []).filter((item) =>
      item.product.includes('confluence')
    ).length > 0;

  if (!userInfo || (isMigrationSignup && !migrationData)) {
    return (
      <SpinnerWrapper>
        <Spinner size="large" />
      </SpinnerWrapper>
    );
  }

  return (
    <>
      <SignUpFormHeader
        {...formHeaderLabels}
        userInfo={props.userInfo as UserDataType}
        allowSignupWithAllSocialOptions={allowSignupWithAllSocialOptions}
        products={props.productKeys}
      />
      {enableDefaultExpandedEmail || isConfluence ? (
        <RightContainerContentDefaultExpandedEmail>
          <Signup
            {...props}
            fadeOnDisable={true}
            outlineOnFocus={true}
            showWarningIcon={true}
            hideCaptchaEula={false}
            hideGreeting={true}
          />
        </RightContainerContentDefaultExpandedEmail>
      ) : (
        <RightContainerContent>
          <Signup
            {...props}
            fadeOnDisable={true}
            outlineOnFocus={true}
            showWarningIcon={true}
            hideCaptchaEula={false}
            hideGreeting={true}
          />
        </RightContainerContent>
      )}
      {!isConfluence && (
        <LogoWrapper>
          {allowSignupWithAllSocialOptions ? (
            <span
              style={
                isLoggedIn ? { display: 'block', marginTop: '24px' } : undefined
              }
            >
              <AtlassianLogo
                appearance="brand"
                size={isLoggedIn ? 'xsmall' : 'small'}
              />
            </span>
          ) : (
            <AtlassianLogo appearance="brand" size="xsmall" />
          )}
        </LogoWrapper>
      )}
    </>
  );
}

const SpinnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 400px;
  max-width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
